import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@flat-ui";
import { getChartJsData, getChartJsOptions } from "@components/common/sphere-bar-chart/sphere-bar-chart-utils";
import { Box, useTheme } from "@mui-wrapper";
import { BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip } from "chart.js";
import { Bar } from "react-chartjs-2";

/**
 * Chart.js is tree-shakeable, so it is necessary to import and register
 * the controllers, elements, scales and plugins you are going to use.
 * https://www.chartjs.org/docs/latest/getting-started/integration.html#bundlers-webpack-rollup-etc
 */
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

/* eslint-disable @typescript-eslint/no-magic-numbers -- aspect ratio value */
/** Default chart aspect ratio */
const DEFAULT_CHART_ASPECT_RATIO = 4 / 3;
/* eslint-enable @typescript-eslint/no-magic-numbers */

/** Renders a single Sphere bar chart */
export function SphereBarChart(t0) {
  const $ = _c(12);
  const {
    data,
    aspectRatio: t1,
    shouldShowSkeleton: t2,
    shouldHideTitle: t3,
    sx
  } = t0;
  const aspectRatio = t1 === undefined ? DEFAULT_CHART_ASPECT_RATIO : t1;
  const shouldShowSkeleton = t2 === undefined ? false : t2;
  const shouldHideTitle = t3 === undefined ? false : t3;
  const theme = useTheme();
  let t4;
  if ($[0] !== aspectRatio || $[1] !== sx) {
    t4 = {
      width: "100%",
      aspectRatio,
      ...sx
    };
    $[0] = aspectRatio;
    $[1] = sx;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== aspectRatio || $[4] !== data || $[5] !== shouldHideTitle || $[6] !== shouldShowSkeleton || $[7] !== theme) {
    t5 = data && !shouldShowSkeleton ? <Bar options={getChartJsOptions({
      data,
      palette: theme.palette,
      aspectRatio,
      shouldShowTitle: !shouldHideTitle
    })} data={getChartJsData({
      data
    })} /> : <Skeleton variant="rectangular" sx={{
      width: "100%",
      height: "100%"
    }} />;
    $[3] = aspectRatio;
    $[4] = data;
    $[5] = shouldHideTitle;
    $[6] = shouldShowSkeleton;
    $[7] = theme;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <Box component="div" sx={t4}>{t5}</Box>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}